import { render } from "./AttractionTabView.vue?vue&type=template&id=6212512a"
import script from "./AttractionTabView.vue?vue&type=script&lang=js"
export * from "./AttractionTabView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__